import React from 'react';
import styled from 'styled-components';

import PerPage from 'common/components/category/PerPage';
import AppPagination from 'common/components/_partials/pagination';
import { withCssUnit } from 'common/components/styleguide/utils';

const StyledWrapper = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  @media (max-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    display: block;
  }
`;

const PaginationWithPerPage = ({ afterClick = null }) => {
  return (
    <StyledWrapper>
      <AppPagination afterClick={afterClick} />
      <PerPage />
    </StyledWrapper>
  );
};

export default PaginationWithPerPage;
